export const formatGlobalActionDateTime = (date) => {
  if (!date) return '';

  const dateObj = new Date(date);

  if (Number.isNaN(dateObj.getTime())) {
    return '';
  }

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const formatGlobalActionDateISO = (date) => {
  if (!date) return '';

  const dateObj = new Date(date);

  if (Number.isNaN(dateObj.getTime())) {
    return '';
  }

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed, so we add 1 and pad with zero if needed
  const day = String(dateObj.getDate()).padStart(2, '0'); // Pad with zero if less than 2 characters

  return `${year}-${month}-${day}`;
};

// Returns the hours and minutes in HH:MM format from a given date object
export const formatGlobalActionTimeHM = (time) => {
  if (!time) return '';

  const dateObj = new Date(time);

  if (Number.isNaN(dateObj.getTime())) {
    return '';
  }

  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`;
};